module.exports = __webpack_public_path__ + "img/ic_marker_asset_blue.dfe6c8e2.png";